import { render, staticRenderFns } from "./Trips.vue?vue&type=template&id=4ea4dcc8&"
import script from "./Trips.vue?vue&type=script&lang=js&"
export * from "./Trips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports